import { ConstantsParser } from '../../ConstantsParser'
export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
    console.log(this.ids, this.classes, this.content)
  }

  build() {
    return `<wfs-form
      action="${this.content.action}"
      ${this.content.hasHoneypot ? 'honeypot' : ''}
      ${this.content.hasRecaptcha ? 'recaptcha' : ''}
      ${this.content.frontendValidation ? 'validate' : ''}
      ${this.sendMailAttributes()}
      ${this.marketingAttributes()}
    >
      ${this.buildRows()}
    </wfs-form>`
  }

  sendMailAttributes() {
    if(! this.content.sendMail) {
      return ''
    }
    let toMails = this.content.toMails
    if (! Array.isArray(toMails)) {
      toMails = toMails.split(',')
    }
    toMails = toMails.map(mail => mail.trim()).join(',')
    return `send-mail send-mail-subject="${this.content.sendMailSubject}" to-mails="${toMails}"`
  }

  marketingAttributes() {
    if (! this.content.leadList || ! this.content.leadTags) {
      return ''
    }
    let leadTags = this.content.leadTags
    if (! Array.isArray(leadTags)) {
      leadTags = leadTags.split(',')
    }
    leadTags = leadTags.map(mail => mail.trim()).join(',')
    return `lead-tags="${this.leadTags}" lead-list="${this.content.leadList}"`
  }

  buildRows() {
    return this.content.rows.map((row, index) => `<div class="wf-flex wf-flex-wrap wf--mx-2 ${index > 0 ? 'wf-mt-4' : ''}" id="${row.id}">
      ${this.buildColumns(row.columns)}
    </div>`).join('')
  }

  buildColumns(columns) {
    return columns.map(column => `<div id="${column.id}" class="wf-px-2 ${this.parseColumnClasses(column.containerClasses)}">
      ${this.buildComponents(column.components)}
    </div>`).join('')
  }

  buildComponents(components) {
    return components.map(component => this.buildComponentHtml(component)).join('')
  }

  buildComponentHtml(component) {
    if (component.component == 'editor-form-button') {
      return this.buildButton(component)
    }
    return this.buildInput(component)
  }

  buildButton(component) {
    return `<div>
      <button type="submit" id="${this.ids.buttonId}" class="wf-font-bold wf-w-full ${this.classes.buttonClasses}">${component.content.text}</button>
    </div>`
  }

  buildInput(component) {
    if (component.content.type == 'radio') {
      let options = component.content.options.map((option, index) => `<label for="${component.id}_${index}" class="wf-flex wf-my-4 wf-items-center">
        <input id="${component.id}_${index}" ${component.content.required ? 'required' : ''} type="radio" name="${component.name}" value="${option.value}" />
        <span class="wf-ml-2 wf-text-sm wf-leading-none">${option.text}</span>
      </label>`).join('')
      return `<div>
        <span class="wf-form-label ${this.classes.labelClasses}">${component.content.label}</span>
        ${options}
      </div>`
    }

    if (component.content.type == 'select') {
      let options = component.content.options.map(option => `<option value="${option.value}">${option.text}</option>`).join('')
      let label = ''
      if (this.content.showLabels) {
        label = `<label class="wf-form-label wf-w-block ${this.classes.labelClasses}" for="${component.id}">${component.content.label}</label>`
      }
      return `<div>
        ${label}
        <select ${component.content.required ? 'required' : ''} class="wf-w-full focus:wf-outline-none wf-form-input ${this.classes.inputClasses}" name="${component.content.name}" id="${component.id}">
          ${options}
        </select>
      </div>`
    }

    if (component.content.type == 'checkbox') {
      return `<label for="${component.id}" class="wf-flex wf-items-center">
        <input ${component.content.required ? 'required' : ''} id="${component.id}" type="checkbox" name="${component.content.name}">
        <span class="wf-ml-2 wf-text-xs wf-font-semibold">${component.content.label}</span>
      </label>`
    }

    if (component.content.type == 'textarea') {
      let label = ''
      if (this.content.showLabels) {
        label = `<label class="wf-form-label wf-w-block ${this.classes.labelClasses}" for="${component.id}">${component.content.label}</label>`
      }
      return `<div>
        ${label}
        <textarea
          ${component.content.required ? 'required' : ''}
          name="${component.content.name}"
          id="${component.id}"
          class="wf-h-56 wf-w-full focus:wf-outline-none wf-form-input ${this.classes.inputClasses}"
        >${this.content.showPlaceholder ? component.content.placeholder : ''}</textarea>
      </div>`
    }

    let label = ''
    if (this.content.showLabels) {
      label = `<label class="wf-form-label wf-w-block ${this.classes.labelClasses}" for="${component.id}">${component.content.label}</label>`
    }
    return `<div>
      ${label}
      <input
        ${component.content.required ? 'required' : ''}
        ${this.content.showPlaceholder ? 'placeholder="'+component.content.placeholder+'"' : ''}
        class="wf-w-full focus:wf-outline-none wf-form-input ${this.classes.inputClasses}"
        type="${component.content.type}"
        name="${component.content.name}"
        id="${component.id}"
      />
    </div>`
  }

  parseColumnClasses(containerClasses) {
    return (new ConstantsParser(containerClasses)).parseResponsiveClasses().join(' ')
  }
}